import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { LocationsByCompanyHttpService } from './locations-by-company-http.service';
import { LocationsByCompanyActions } from './locations-by-company.store';

@Injectable({
  providedIn: 'root',
})
export class LocationsByCompanyEffects {
  public effects = createEffectFactory(LocationsByCompanyActions, this.actions$);

  public fetch = this.effects(LocationsByCompanyActions.fetchOne, ({ payload }) =>
    this.http.fetchOne$(<string>payload.id).pipe(
      map(response => ({
        data: response,
        id: response.id,
      })),
    ),
  );

  constructor(
    private http: LocationsByCompanyHttpService,
    private actions$: Actions,
  ) {}
}
